import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import TabFeedbacks from '../tabs/TabFeedbacks';
import { apiGet } from '../utils/api-client';

/**
 * FeedbacksInterceptesContainer
 *
 * Endpoint branché :
 *  - GET /api/dashboard/feedbacks → { feedbacks, count_mois, count_total }
 *    (scoping resolveRestaurantId : resto courant ou resto piloté par l'owner
 *    via X-Restaurant-Id auto-injecté par api-client — pas de fuite multi-resto).
 *
 * Les feedbacks contiennent des données perso : visibles uniquement par le
 * restaurateur propriétaire (JWT) ou l'owner en pilotage. Rien en query string.
 */
export default function FeedbacksInterceptesContainer() {
  const { t } = useTranslation('tabs');
  const [feedbacks, setFeedbacks]   = useState([]);
  const [countMois, setCountMois]   = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiGet('/api/dashboard/feedbacks');
      setFeedbacks(Array.isArray(data?.feedbacks) ? data.feedbacks : []);
      setCountMois(data?.count_mois ?? 0);
      setCountTotal(data?.count_total ?? 0);
    } catch (e) {
      console.warn('[Feedbacks] fetch failed:', e.message);
      setError(t('feedbacksInterceptes.error'));
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => { load(); }, [load]);

  return (
    <TabFeedbacks
      feedbacks={feedbacks}
      countMois={countMois}
      countTotal={countTotal}
      loading={loading}
      error={error}
      onRetry={load}
    />
  );
}
